/**
 * FLOW — progressive homepage shelves
 * Above-the-fold stays server-rendered; deferred product lists load on approach.
 */
(function () {
  const MONEY = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-MZ', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MZN',
        maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(0) + ' MT';
    }
  };

  const cardHTML = (p) => {
    const img = (p.images && p.images[0]) || (p.featured_image) || '';
    // products.json returns images as full URLs sometimes, or src paths
    let src = '';
    if (typeof img === 'string') src = img;
    else if (img && img.src) src = img.src;
    if (src && src.startsWith('//')) src = 'https:' + src;
    // request a sane card size from Shopify CDN
    if (src.includes('/cdn/shop/')) {
      src = src.replace(/(\.(jpg|jpeg|png|webp))(\?|$)/i, '_400x$1$3');
      if (!src.includes('_400x') && src.includes('?')) {
        // files CDN style
      }
    }
    // Shopify files CDN resize: append width param
    if (src.includes('/cdn/shop/files/') || src.includes('/cdn/shop/products/')) {
      const join = src.includes('?') ? '&' : '?';
      if (!/[?&]width=/.test(src)) src = src + join + 'width=600';
    }
    const url = p.url || ('/products/' + p.handle);
    const title = p.title || '';
    const price = p.price != null ? MONEY(p.price, p.price_currency || p.currency) : '';
    const compare = p.compare_at_price && p.compare_at_price > p.price
      ? MONEY(p.compare_at_price, p.price_currency || p.currency)
      : '';
    return (
      '<a class="fs-shelf-card" href="' + url + '">' +
        '<div class="fs-shelf-card__media">' +
          (src
            ? '<img src="' + src + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy" decoding="async" width="600" height="900">'
            : '<div class="fs-shelf-card__ph"></div>') +
        '</div>' +
        '<div class="fs-shelf-card__meta">' +
          '<div class="fs-shelf-card__title">' + title + '</div>' +
          '<div class="fs-shelf-card__price">' +
            (compare ? '<s class="fs-shelf-card__compare">' + compare + '</s> ' : '') +
            '<span>' + price + '</span>' +
          '</div>' +
        '</div>' +
      '</a>'
    );
  };

  async function loadShelf(el) {
    if (el.dataset.loaded === '1' || el.dataset.loading === '1') return;
    el.dataset.loading = '1';
    const handle = el.dataset.collection;
    const limit = parseInt(el.dataset.limit || '4', 10) || 4;
    try {
      const res = await fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      const products = data.products || [];
      const grid = el.querySelector('.fs-deferred-shelf__grid');
      if (!grid) return;
      if (!products.length) {
        grid.innerHTML = '<p class="fs-deferred-shelf__empty">Sem produtos</p>';
      } else {
        grid.innerHTML = products.slice(0, limit).map(cardHTML).join('');
      }
      el.dataset.loaded = '1';
      el.classList.add('is-loaded');
    } catch (err) {
      console.warn('[fs-deferred]', handle, err);
      const grid = el.querySelector('.fs-deferred-shelf__grid');
      const viewAll = el.dataset.viewAll || ('/collections/' + handle);
      if (grid) {
        grid.innerHTML = '<p class="fs-deferred-shelf__empty"><a href="' + viewAll + '">Ver coleção</a></p>';
      }
    } finally {
      el.dataset.loading = '0';
    }
  }

  function init() {
    const nodes = Array.from(document.querySelectorAll('[data-fs-deferred-shelf]'));
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(loadShelf);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            loadShelf(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      // Start loading a bit before the section enters the viewport
      { rootMargin: '400px 0px', threshold: 0.01 }
    );

    nodes.forEach((n) => io.observe(n));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
